const SOURCE_SETUP = Object.freeze({
  preview: (content) => {
    return content.previewSources.map((url) => {
      return {
        src: removeAudioTrack([url]),
        type: 'application/x-mpegURL',
      };
    });
  },

  countdown: (content) => {
    return content.countdownSources.map((url) => {
      return {
        src: removeAudioTrack([url]),
        type: 'application/x-mpegURL',
      };
    });
  },

  playback: (content) => {
    return content.defaultSources.map((url) => {
      return {
        src: removeAudioTrack([url]),
        type: 'application/x-mpegURL',
        withCredentials: false,
      };
    });
  },

  playbackAES: (content) => {
    return content.aesSources.map((url) => {
      return {
        src: removeAudioTrack([url]),
        type: 'application/x-mpegURL',
        withCredentials: false,
      };
    });
  },

  playbackFairplay: (content) => {
    return content.fairplaySources.map((url) => {
      return {
        src: removeAudioTrack([url]),
        type: 'application/x-mpegURL',
        keySystems: _InjectFairplay(content.aestoken),
      };
    });
  },
});

/**
 * Transcode HLS sources to DASH sources
 * @param {*} sources
 * @returns {Array<{src: string, type: string, keySystems?: object}>} - array of sources
 */
function _transcodeToDASH(sources) {
  return sources.map((source) => {
    return {
      ...source,
      src: source.src
        .replace('format=m3u8-aapl-v3', 'format=mpd-time-csf')
        .replace('format=m3u8-aapl', 'format=mpd-time-csf'),
      type: 'application/dash+xml',
    };
  });
}

/**
 * Remap default source structure to concatinate sources structure
 * @param {*} sources
 * @returns {Array<{url: string, mimeType: string, keySystems?: object}>} - array of sources
 */
function _remapForConcat(sources) {
  return sources.map((source) => {
    return {
      ...source,
      url: source.src,
      mimeType: source.type,
    };
  });
}

// function _injectAESAuth(aestoken = '') {
//   videojs.Vhs.xhr.beforeRequest = function (options) {
//     if (options.uri.includes('keydelivery')) {
//       options.headers = { ...options.headers, Authorization: `Bearer ${aestoken}` };
//       options.uri = `${options.uri}&token=${aestoken}`;
//     }
//     if (options.uri.includes('Fragments')) {
//       options.uri = `${options.uri}/?token=${aestoken}`;
//     }
//     return options;
//   };
//   videojs.Hls.xhr.beforeRequest = function (options) {
//     if (options.uri.includes('keydelivery')) {
//       options.headers = { ...options.headers, Authorization: `Bearer ${aestoken}` };
//       options.uri = `${options.uri}&token=${aestoken}`;
//     }
//     if (options.uri.includes('Fragments')) {
//       options.uri = `${options.uri}?token=${aestoken}`;
//     }
//     return options;
//   };
// }

// function _formatTime(seconds) {
//   // Calculate the minutes and seconds
//   const minutes = Math.floor(seconds / 60);
//   const secondsRemainder = Math.floor(seconds % 60);

//   // Pad the minutes and seconds with leading zeroes if necessary
//   const paddedMinutes = minutes.toString().padStart(2, '0');
//   const paddedSeconds = secondsRemainder.toString().padStart(2, '0');

//   // Combine the minutes and seconds into a string
//   const formattedTime = `${paddedMinutes}:${paddedSeconds}`;

//   // Return the formatted time
//   return formattedTime;
// }

//  =========================================HELPERS=========================================================

function removeAudioTrack(urls = []) {
  const result = urls.map((url) => {
    if (!new RegExp('\\baudio-only\\b').test(url)) {
      return url.replace('format=m3u8-aapl-v3', 'format=m3u8-aapl,audio-only=false');
    }

    return url;
  });

  return result.length <= 1 ? result[0] : result;
}

export const usePlayerSources = ({
  content,
  preview = false,
  concat = false,
  countdown = false,
  is360 = false,
}) => {
  try {
    if (preview) {
      return SOURCE_SETUP.preview(content);
    }

    if (countdown) {
      return SOURCE_SETUP.countdown(content);
    }

    if (concat) {
      return _remapForConcat(_transcodeToDASH(SOURCE_SETUP.playback(content)));
    }

    if (is360) {
      return SOURCE_SETUP.playback(content);
    }

    /**
     * If IS_SAFARI and content have FairplaySources, works only with HLS
     */
    // if (videojs.browser.IS_ANY_SAFARI && videojs.browser.IS_IOS) {
    //   return SOURCE_SETUP.playback(content);
    // }

    if (content?.sourceType === 'live') {
      return SOURCE_SETUP.playback(content);
    }

    // _injectAESAuth(content.aestoken);
    return [
      //   ...SOURCE_SETUP.playbackAES(content),
      // ..._transcodeToDASH(SOURCE_SETUP.playback(content)),
      ...SOURCE_SETUP.playback(content),
    ];
  } catch (error) {
    console.warn(`Error parsing sources: ${error}`);
    return [];
  }
};

// module.exports = {
//   _parseSources,
//   _injectAESAuth,
//   _formatTime,
// };
